const map = {
	"./ar.png": 3955,
	"./ch.png": 1199,
	"./de.png": 1303,
	"./fr.png": 2370,
	"./id.png": 4893,
	"./in.png": 6711,
	"./it.png": 5309,
	"./pt.png": 9218,
	"./sp.png": 9431,
	"./us.png": 5038
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7077;